var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "container",
      staticClass:
        "w-full whitespace-nowrap overflow-x-auto drag-scroll-wrapper",
      class: _vm.classes,
      on: { mousedown: _vm.mouseDownHandler },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }